<template>
  <span :class="badgeClass">{{ textType }}</span>
</template>
<script>

export default {
  name: 'AccountType',
  props: [ 'type' ],
  computed: {
    textType: function () {
      if (this.type == 'residential') {
        return 'Residential'
      } else if (this.type == 'business') {
        return 'Business'
      } else {
        return 'Unknown'
      }
    },
    badgeClass: function () {
      if (this.type == 'residential') {
        return 'badge badge-primary'
      } else if (this.type == 'business') {
        return 'badge badge-success'
      } else {
        return 'badge badge-secondary'
      }
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped></style>
